import { ENV_CONFIG, PATH } from '../../config';

const params = {
  sentryUrl: ENV_CONFIG.AUTOPARTNER_SENTRY_URL,
  uid: ENV_CONFIG.AUTOPARTNER_UID,
  ga: ENV_CONFIG.AUTOPARTNER_GA,
  mqtt: true,
  supportPass: true,
  supportBarcodePayment: true,
  supportService: ['refueling', 'parking', 'on-street-parking'],
  routes: {
    loginFlow: {
      welcomeNext: PATH.USER_LOGIN,
    },
  },
  bottomTabs: ['main', 'maps', 'orders', 'coins'],
  welcome: {
    laterButton: true,
    clearAuth: false,
  },
  main: {
    featureListBottom: ['coupon', 'promotions', 'contact'],
    settingButton: true,
  },
  setting: {
    logout: true,
  },
  licensePlates: {
    helpButton: true,
    addPlate: true,
    dialog: [
      'rebind-taipei-city-parking',
      'rebind-on-street-parking',
      'manage-pass',
      'edit',
      'delete',
      'cancel',
    ],
  },
  promotions: [
    'RefuelingPromotion',
    'ParkingPromotion',
    'OnStreetParkingPromotion',
  ],
  autopay: {
    searchBills: true,
  },
};

export default params;
